import { ROUTES } from 'config';
import { AnalyticsEvents } from 'enums';
import { useCheckRoles, useCurrentUser } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'redux/hooks';
import { Text } from 'view/atoms';
import { UserRole } from 'interfaces';
import { notificationsSelectors } from 'redux/modules/Notifications';
import { captureEvent } from 'utils/analytics/captureEvent';
import * as S from './RequestDiscountButton.style';

export const RequestDiscountButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useCurrentUser();

  const unreadNotificationCounts = useAppSelector(
    notificationsSelectors.getUnreadNotificationCounts,
  );

  const isForAnyMod = useCheckRoles(
    UserRole.Admin,
    UserRole.Mod,
    UserRole.Super,
  );

  const onClickHandler = () => {
    if (user?.id) {
      captureEvent(AnalyticsEvents.RequestDiscountButtonClick, {
        user_id: String(user.id),
      });
    }
    return isForAnyMod
      ? navigate(ROUTES.requestDiscountAll)
      : navigate(ROUTES.requestDiscount);
  };

  return (
    <S.RequestDiscountButton
      data-testid='RequestDiscountButton'
      kind='primary'
      onClick={onClickHandler}
    >
      <Text kind='button'>
        {!isForAnyMod
          ? t('other.requestDiscount')
          : t('other.getRequestDiscount')}
      </Text>
      {isForAnyMod && !!unreadNotificationCounts && (
        <S.RequestCountWrapper>
          <Text kind='button'>{unreadNotificationCounts}</Text>
        </S.RequestCountWrapper>
      )}
    </S.RequestDiscountButton>
  );
};
